/**
 * Automatischer Hoher-Kontrast — kein Button nötig.
 * Optimiert für POS-Displays, Sonnenlicht und günstige Bildschirme.
 */

export function applyAutomaticContrast() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  const root = document.documentElement;

  const apply = () => {
    const prefersMore = window.matchMedia('(prefers-contrast: more)').matches;
    const forcedColors = window.matchMedia('(forced-colors: active)').matches;
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    const compact = window.matchMedia('(max-width: 960px)').matches;

    if (prefersMore || forcedColors || coarse || compact) {
      root.setAttribute('data-contrast', 'high');
    } else {
      root.removeAttribute('data-contrast');
    }
  };

  apply();

  const queries = [
    window.matchMedia('(prefers-contrast: more)'),
    window.matchMedia('(forced-colors: active)'),
    window.matchMedia('(pointer: coarse)'),
    window.matchMedia('(max-width: 960px)')
  ];

  for (const mq of queries) {
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(apply);
    }
  }
}
